import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";

export const Layout = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-night">
      <div className="flex flex-1">
        {pathname !== "/" && <Sidebar />}
        <div className={`flex flex-1 flex-col ${pathname !== "/" ? "pb-20 md:pb-0" : ""}`}>
          <Outlet />
          <footer className="py-5 text-center text-sm text-white/50">
            © Неопепло — захищено авторським правом
          </footer>
        </div>
      </div>
    </div>
  );
};
